import type { DriveStep } from 'driver.js';

export const posTablesTour: DriveStep[] = [
  {
    element: '[data-tour="pos-tables-filters"]',
    popover: {
      title: 'Table status filter',
      description:
        'Use the side panel to filter tables by status — available, reserved, occupied, or cleaning. Counts update live.',
      side: 'left',
      align: 'center',
    },
  },
  {
    element: '[data-tour="pos-tables-toolbar"]',
    popover: {
      title: 'Zones & layout',
      description:
        'Filter by dining zone, switch between grid and floor-plan view, and add new tables from here.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '[data-tour="pos-tables-grid"]',
    popover: {
      title: 'Table floor',
      description:
        'Each table card shows capacity and status. Click a table to update status or start an order. Colour indicates whether the table is free, serving, or being cleaned.',
      side: 'top',
      align: 'start',
    },
  },
];
